import {
    TBody,
    THead,
    Table,
    TableWrapper,
    Td,
    Th,
    Tr,
  } from "Components/Common/Table/TableT1";
  import { TypographyT40 } from "Components/Common/Typography/index";
  import React, { Fragment } from "react";
  import Moment from "moment";
  
  const EventStatus = (props) => {
    const { data } = props;
    return (
      <Fragment>
        <TableWrapper>
          <Table>
            <THead>
              <Tr>
                <Th>Current Status</Th>
                <Th>Current Location</Th>
                <Th>Transport Mode</Th>
                <Th>Time Stamp</Th>
              </Tr>
            </THead>
            <TBody>
              {(data.trackLog || []).map(
                (track, index) => {
                  return (
                    <Fragment key={index}>
                      <Tr>
                        <Td>
                            <TypographyT40>{track.eventname}</TypographyT40>
                        </Td>
                        <Td>
                            <TypographyT40>{track.currentlocation}</TypographyT40>
                        </Td>
                        <Td>
                            <TypographyT40>{track.transportmode}</TypographyT40>
                        </Td>
                        <Td>
                            <TypographyT40>
                                {!!track.timestamptimezone &&
                                Moment(track.timestamptimezone).format(
                                    "DD/MM/YYYY HH:mm:ss"
                                )}
                            </TypographyT40>
                        </Td>
                      </Tr>
                    </Fragment>
                  );
                }
              )}
            </TBody>
          </Table>
        </TableWrapper>
      </Fragment>
    );
  };
  
  export default EventStatus;
  